import { useEffect, useRef, type ComponentProps } from "react";
import { AudioControls } from "./audio-controls.tsx";

export function AudioSettingsDialog({ onClose, ...props }: ComponentProps<typeof AudioControls> & { onClose: () => void }) {
  const dialog = useRef<HTMLDialogElement>(null);
  useEffect(() => {
    const element = dialog.current;
    const previous = document.activeElement;
    element?.showModal();
    return () => { element?.close(); if (previous instanceof HTMLElement && previous.isConnected) previous.focus(); };
  }, []);
  return <dialog ref={dialog} className="audio-dialog" aria-labelledby="audio-dialog-title" onCancel={event => { event.preventDefault(); onClose(); }}>
    <header><h2 id="audio-dialog-title">Configurações de áudio</h2><button type="button" autoFocus onClick={onClose} aria-label="Fechar configurações">×</button></header>
    <AudioControls {...props} dialogMode />
  </dialog>;
}
